import React from "react";
import { CircularProgress, Grid, Box, Stepper, StepLabel, Step, Typography  } from "@mui/material";
import TOTPQR from './TOTPQR';
import { MuiOtpInput } from 'mui-one-time-password-input';
import useTheme from "@mui/material/styles/useTheme";
import { FormattedMessage } from "react-intl";

const AuthenticatorSetupContent = ({
  activeStep,
  username,  
  secret,  
  otp,
  onOtpChange,
  onVerify
}) => {

  const stepColor =
  {
    '& .MuiStepLabel-iconContainer .Mui-completed': {
      color: '#00c9b7', // text color (COMPLETED)
    },
    '& .MuiStepLabel-labelContainer .Mui-completed': {
      color: 'rgba(0, 0, 0, 0.87)', // text color (COMPLETED)
      fontWeight: 600,
    },
    '& .MuiStepLabel-iconContainer .Mui-active': {
      color: '#00c9b7', // circle color (ACTIVE)
    },
    '& .MuiStepLabel-labelContainer .Mui-active': {
      color: 'rgba(0, 0, 0, 0.87)', // circle color (ACTIVE)
      fontWeight: 600,
    },
    '& .MuiStepIcon-text': {
      fontWeight: 600,
    },
  };

  const informationText = {
    marginTop: "1em",
    fontSize: "14px",
    lineHeight: "18px",
  };

  const informationTextItalic = {
    marginTop: "1em",
    fontSize: "14px",
    lineHeight: "18px",
    fontStyle: 'italic',
  };

  const steps = [<FormattedMessage id="users.security.totp_setup.step.scan" />,
    <FormattedMessage id="users.security.totp_setup.step.verify" />,
    <FormattedMessage id="users.security.totp_setup.step.complete" />];

  return (<>

    <Stepper activeStep={activeStep}>
      {steps.map((label, index) => {
        const stepProps = {};
        const labelProps = {};

        return (
          <Step sx={stepColor} key={label} {...stepProps}>
            <StepLabel {...labelProps}>{label}</StepLabel>
          </Step>
        );
      })}
    </Stepper>
    <Grid container spacing={2} sx={{ padding: 2 }}>

      {activeStep === 0 && (<>
        <Grid item xs={6}>
          <Box align="middle">
            {secret && (
              <TOTPQR size={200} username={username} secret={secret} issuer={"UniQueue"} />)}
            {!secret && (<CircularProgress size={200} />)}
          </Box>
        </Grid>
        <Grid item xs={6}>
          <Typography sx={informationText}><FormattedMessage id="users.security.totp_setup.scan_instruction_1" /></Typography>
          <Typography sx={informationTextItalic}><FormattedMessage id="users.security.totp_setup.scan_instruction_2" /></Typography>
          <Typography sx={informationText}> <FormattedMessage id="users.security.totp_setup.scan_instruction_3" /></Typography>
        </Grid>
      </>)}

      {activeStep === 1 && (
        <>
          <Grid item xs={12}><FormattedMessage id="users.security.totp_setup.enter_code" /></Grid>
          <Grid item xs={12}><MuiOtpInput autoFocus value={otp} onChange={onOtpChange} onComplete={ onVerify } length={6} /></Grid>
        </>
      )}

      {activeStep === 2 && (
        <Grid item xs={12}><FormattedMessage id="users.security.totp_setup.verified" /></Grid>
      )}
    </Grid>

  </>);
}

export default AuthenticatorSetupContent;